<script>
import { storeName } from "@/global/variable";
import { VueSpinner } from "vue3-spinners";
import { mapActions } from "vuex";

export default {
  name: "MarginTypeModal",
  props: {
    coinName: String,
  },
  components: {
    VueSpinner,
  },
  created() {
    this.symbolName = this.coinName;
  },
  mounted() {
    this.before = this.$store.getters[`${storeName.asset}/ASSET_CONFIG`](
      this.symbolName
    )?.marginType;
  },
  data() {
    return {
      before: null,
      after: "",
      isLoading: false,
    };
  },
  methods: {
    ...mapActions(storeName.asset, ["AT_MODIFY_MARGIN_TYPE"]),
    async updateMarginType() {
      if (!confirm("해당 타입으로 변경하시겠습니까?")) return false;

      const payload = {
        symbol: this.symbolName,
        type: this.after,
      };
      this.isLoading = true;
      await this.AT_MODIFY_MARGIN_TYPE(payload);
      this.isLoading = false;
    },
  },
};
</script>
<template>
  <div class="common-modal-wrap">
    <div class="pc-modal-content">
      <div class="pc-modal-header">
        <h2 class="text-lg font-bold">마진 타입 변경</h2>
        <button @click="$emit('modal-close')" class="text-gray-500">
          닫기
        </button>
      </div>
      <div class="pc-modal-description-wrap">
        <p class="font-bold text-red-500">
          LONG,SHORT 포지션에 일괄 적용 됩니다.
        </p>
      </div>

      <div class="px-4 py-2">
        <p class="w-full text-left font-bold mb-2">{{ coinName }}</p>
        <p class="w-full text-left mb-1 text-gray-400">현재 마진 타입</p>
        <div class="mb-4 w-full">
          <input
            type="text"
            class="px-2 py-1 w-full"
            placeholder="기존 마진타입"
            v-model="before"
            disabled
          />
        </div>
        <p class="w-full text-left mb-1 text-gray-400">변경 값</p>
        <div class="w-full">
          <select class="w-full" v-model="after">
            <option value="" selected>선택해주세요</option>
            <option value="CROSSED">CROSSED</option>
            <option value="ISOLATED">ISOLATED</option>
          </select>
        </div>
      </div>

      <div class="p-4">
        <button
          @click="updateMarginType"
          class="bg-blue-500 text-white w-full py-2 rounded"
          v-bind:disabled="isLoading"
        >
          <div v-if="isLoading" class="flex justify-center">
            <VueSpinner size="20"></VueSpinner>
          </div>

          <span v-else>저장</span>
        </button>
      </div>
    </div>
  </div>
</template>
